import {
    useMemo, useCallback,
    useState,
} from 'react'

import useLocalStorage, {
    LocalStorageKeys,
} from 'app/hooks/useLocalStorage'

import {
    SkyAccordionLocalStorage,
} from './types'

const extendedInitState: SkyAccordionLocalStorage = {
    extended: true,
}

const usePersistedExtendedState = ({
    persistentKey,
    enablePersistence = true,
}:{
    persistentKey: string,
    enablePersistence?: boolean,
}): [boolean, (value: boolean) => void] => {
    const {
        dataGridState,
        setDataGridState: setLocalState,
    } = useLocalStorage<SkyAccordionLocalStorage>({
        key: LocalStorageKeys.SKY_NET_ALL_ACCORDION_DASHBOARD_KEY,
        value: persistentKey,
        defaultValue: extendedInitState,
    })

    const [
        extended,
        setExtended,
    ] = useState<boolean>(true)

    const onExtendedStateChange = useCallback((newExtended: boolean) => {
        if (enablePersistence) {
            setLocalState({
                extended: newExtended,
            })
        } else {
            setExtended(newExtended)
        }
    }, [
        enablePersistence,
        setLocalState,
    ])

    const extendedState = useMemo(() => {
        if (enablePersistence) {
            if (dataGridState?.extended === undefined) {
                return true
            }
            return dataGridState?.extended
        }
        return extended
    }, [
        dataGridState,
        enablePersistence,
        extended,
    ])

    return [
        extendedState,
        onExtendedStateChange,
    ]
}

export default usePersistedExtendedState
